import { useProgress } from '@react-three/drei'
import { useEffect, useState } from 'react'
import './styles.css'

export default function Loader() {
  const { progress, active } = useProgress()
  const [displayProgress, setDisplayProgress] = useState(0)
  const [show, setShow] = useState(true)

  useEffect(() => {
    if (progress >= 99 && !active) {
      // 99% da 1s kutib, keyin 100% ko'rsatish
      setDisplayProgress(99)
      const timer = setTimeout(() => {
        setDisplayProgress(100)
        setTimeout(() => setShow(false), 600)
      }, 1000)
      return () => clearTimeout(timer)
    } else {
      setDisplayProgress(Math.round(progress))
    }
  }, [progress, active])

  if (!show) return null

  return (
    <div className={`loader ${displayProgress === 100 ? 'fade-out' : ''}`}>
      <div className="loader-content">
        {/* Logo */}
        <div className="loader-logo">
          <img src="/logo.svg" alt="Xbox" />
        </div>

        {/* Progress */}
        <div className="loader-progress-wrapper">
          <div className="loader-line">
            <div
              className="loader-line-fill"
              style={{ width: `${displayProgress}%` }}
            />
          </div>

          <div className="loader-info">
            <span className="loader-percent">{displayProgress}%</span>
            <span className="loader-arrow">→</span>
          </div>
        </div>

        {/* Text */}
        <p className="loader-text">Loading</p>
      </div>
    </div>
  )
}
